import type { MenuListItemProps } from "@/app/AppShellMenuListItem.js";
import type { OAuth2Provider } from "@/feature-auth/components/AuthenticateForm.js";
import type { AuthTokenObject } from "@/feature-auth/models/token-model.mjs";
import DiscordLogo from "@/inline-assets/login-discord.svg";
import GoogleLogo from "@/inline-assets/login-google.svg";
// import TwitchLogo from "@/inline-assets/login-twitch.svg";

export const LOGIN: MenuListItemProps = {
  text: ["common:login", "Login"],
  href: "/account",
};

export const LOGOUT: MenuListItemProps = {
  text: ["common:logOut", "Log Out"],
  href: "/account",
};

export const USER_ROLES = {
  adFree: "AD_FREE",
  admin: "ADMIN",
  teamCoaching: "TEAM_COACHING",
  subscriber: "PRO_SUBSCRIBER",
  nonSubscriber: "FREE_PRO_SUBSCRIBER",
  cryptoProSubscriber: "CRYPTO_PRO_SUBSCRIBER",
};

export const OAUTH2_PROVIDERS: Record<string, OAuth2Provider> = {
  DISCORD: {
    id: "discord",
    logo: DiscordLogo,
    color: "#5865F2",
  },
  GOOGLE: {
    id: "google",
    logo: GoogleLogo,
    color: "#E3E5EA",
  },
  // TWITCH: {
  //   id: "twitch",
  //   logo: TwitchLogo,
  //   color: "#6441A5",
  // },
};

export const GENDER_OPTIONS = [
  {
    value: "MALE",
    label: ["common:account.genders.male", "Male"],
  },
  {
    value: "FEMALE",
    label: ["common:account.genders.female", "Female"],
  },
  {
    value: null,
    label: ["common:account.genders.none", "Prefer not to say"],
  },
];

export const CMS_ACCESS = "5";

interface AuthState {
  token: AuthTokenObject | null;
}

declare module "@/__main__/app-state.mjs" {
  interface FeatureState {
    auth: AuthState;
  }
}
